import { ref, computed } from 'vue'
import { getRoleAccessConfig } from '@/api/UserPreferencesService'

const ROLES_WITH_PERMISSIONS = ['TECHNICAL1', 'TECHNICAL2', 'TECHNICAL3', 'COUNTER', 'CERTIFIER', 'SUPERVISOR']

// ✅ Singleton real — fuera de la función, a nivel de módulo
const permissions = ref([])
const role = ref(null)
const plantId = ref(null)
const loaded = ref(false)
const loading = ref(false)

export function usePermissions() {

  const loadPermissions = async (pId, pRole) => {
    role.value = pRole
    plantId.value = pId

    if (!ROLES_WITH_PERMISSIONS.includes(pRole)) {
      loaded.value = true
      return
    }

    loading.value = true
    try {
      const response = await getRoleAccessConfig(pId, pRole)
      permissions.value = response.data ?? []
      loaded.value = true
    } catch (e) {
      console.error('[usePermissions] Error cargando permisos:', e)
      permissions.value = []
      loaded.value = false
    } finally {
      loading.value = false
    }
  }

  const canAccess = (accessType, resource) => {
    if (!ROLES_WITH_PERMISSIONS.includes(role.value)) return true
    if (!loaded.value) return false

    const item = permissions.value.find(
      p => p.accessType === accessType && p.resource === resource
    )
    return item?.hasAccess ?? false
  }

  const clearPermissions = () => {
    permissions.value = []
    role.value = null
    plantId.value = null
    loaded.value = false
    loading.value = false
  }

  const menu = computed(() => {
    const map = {}
    permissions.value
      .filter(p => p.accessType === 'MENU')
      .forEach(p => { map[p.resource] = p.hasAccess })
    return map
  })

  const panel = computed(() => {
    const map = {}
    permissions.value
      .filter(p => p.accessType === 'PANEL')
      .forEach(p => { map[p.resource] = p.hasAccess })
    return map
  })

  return {
    permissions: computed(() => permissions.value),
    role: computed(() => role.value),
    loaded,      // ✅ ref directo, reactivo
    loading,
    loadPermissions,
    canAccess,
    clearPermissions,
    menu,
    panel,
  }
}